import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
  };

  /**
   *
   */
  mounted() {
    this.stickyValue = this.$el.offsetHeight;

    document.documentElement.style.setProperty(
      '--header-sticky',
      `${this.stickyValue}px`,
    );

    if (window.scrollY > this.stickyValue) {
      document.body.classList.add('is-sticky');
    }
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < this.stickyValue;

    toggleClass(document.body, 'is-on-top', isOnTop);
    toggleClass(document.body, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.body, 'is-sticky', !isNearTop);
    toggleClass(document.body, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.body, 'is-scrolling-up', direction.y === 'UP');
  }
}
